import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, NgForm, Validators } from '@angular/forms';
import { PortalV2Service } from '../_services/main/portalv2.service';

@Component({
  selector: 'app-savings-estimate',
  templateUrl: './savings-estimate.component.html',
  styleUrls: ['./savings-estimate.component.scss']
})
export class SavingsEstimateComponent implements OnInit {
  estimatedSavings: any;
  billAmount: any;
  noOfLines: any;
  constructor(private _formBuilder: FormBuilder, private _portalService: PortalV2Service) {}
  ngOnInit() {}
  getEstimatedSavings() {
    if (!this.billAmount) {
      return;
    }
    const data = {
      billAmount: this.billAmount,
      providerName: 'AT&T'
    };
    this._portalService.getEstimatedSavings(data).subscribe(
      resp => {
        this.estimatedSavings = resp.data;
      },
      error => {
        console.log('error', error);
      }
    );
  }
}



// WEBPACK FOOTER //
// ./src/app/savings-estimate/savings-estimate.component.ts